import React, { Fragment, useState, useEffect } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import users from './api/tweets'
import press from './api/press'
import focus from './api/focus'
import certs from './api/certificates'
import { connect, twitterverse, loading, certificate, singleUser } from './components/helpers/links'
import { createStars } from './components/helpers/functions'
import Dashboard from './components/Dashboard'
import ConnectEmail from './components/ConnectEmail'
import UserPage from './components/users/UserPage'
import Certificate from './components/users/Certificate'
import Loading from './components/Loading'
import Welcome from './components/Welcome'
import Head from './components/Head'

const App = () => {
  const data = []

  function prepAccounts(array, pressBool) {
    array.forEach((user) => {
      if (focus.indexOf(user.username) !== -1) {
        user.focus = true
      }
      if (pressBool) {
        user.press = true
      }

      certs.some(function (cert) {
        if (cert.fields.username === user.username) {
          user.cert = cert.fields
          return true
        }
        return false
      })

      const img = user.response.data.user.display_picture.split('/').pop()
      const filename = img.replace('_normal', '_200x200')
      const cdn = 'https://ixi4jeb43ehhpm46.s3.us-east-1.amazonaws.com/twitterverse/users/'
      const updatedImg = `${cdn}${filename}`
      user.response.data.user.display_picture = updatedImg

      user.username = user.username.toLowerCase()
      user.response.data.user.username = user.response.data.user.username.toLowerCase()

      data.push(user)
    })
  }

  prepAccounts(users)
  prepAccounts(press, true)

  if (isMobile) {
    console.log(`mobile`)
    // data = data.slice(0, 199)
  }

  const [tweets] = useState(data)

  useEffect(() => {
    createStars(1, 100)
    createStars(2, 85)
    // createStars(3, 100)
  }, [])

  return (
    <Fragment>
      <Head />
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Welcome} />
          <Route path={twitterverse} render={() => <Dashboard tweets={tweets} />} />
          <Route path={connect} component={ConnectEmail} />
          {/* <Route path={`${connect}/:username`} component={Connect} /> */}
          <Route path={`${singleUser}/:username`} render={(props) => <UserPage {...props} tweets={tweets} connectBool={false} />} />
          <Route exact path={`${certificate}/:username`} render={(props) => <Certificate {...props} tweets={tweets} />} />
          <Route exact path={loading} render={() => <Loading />} />
        </Switch>
      </BrowserRouter>
    </Fragment>
  )
}

export default App
